import type { FC, ReactNode } from 'react'

import type { WhiteLabel } from '@skytech/types'
import { twMerge } from 'tailwind-merge'

import './styles.scss'

// TODO: refactor to use Tailwind CSS classes for font-sizes
export type StyledTextSize =
  | 'xs'
  | 'small'
  | 'sm'
  | 'regular'
  | 'regular-plus'
  | 'large'
  | 'xl'
  | 'xxl'
// TODO: refactor to use "success, warning, error, info, primary" scheme
export type ColorMode = 'gray' | 'black' | 'orange' | 'red' | 'green' | 'warning'
export type FontWeight = 'standard' | 'thin' | 'semibold' | 'bold'

export const StyledText: FC<{
  children: ReactNode
  id?: string
  href?: string
  size?: StyledTextSize
  isDarkenedOnHover?: boolean
  isActive?: boolean
  colorMode?: ColorMode
  className?: string
  fontWeight?: FontWeight
  capitalize?: boolean
  block?: boolean
  marginBottom?: number
  marginRight?: number
  marginTop?: number
  marginLeft?: number
  noMargin?: boolean
  noPadding?: boolean
  whiteLabel?: WhiteLabel
}> = ({
  children,
  id,
  size = 'regular',
  colorMode = '',
  className = '',
  fontWeight = 'standard',
  block,
  marginBottom,
  marginRight,
  marginTop,
  marginLeft,
  noMargin,
  noPadding,
  capitalize,
  isDarkenedOnHover,
  isActive,
  whiteLabel: _whiteLabel,
}) => {
  // todo: replace with the org from url when ready
  const storedWhiteLabel = localStorage.getItem('org') as WhiteLabel
  const whiteLabel = _whiteLabel || storedWhiteLabel || 'control'

  const style: Record<string, number> = {}

  if (marginBottom !== undefined) style.marginBottom = marginBottom
  if (marginRight !== undefined) style.marginRight = marginRight
  if (marginTop !== undefined) style.marginTop = marginTop
  if (marginLeft !== undefined) style.marginLeft = marginLeft

  if (noPadding) style.padding = 0
  if (noMargin) style.margin = 0

  return (
    <span
      id={id}
      style={style}
      // todo: add the disabled mode
      className={twMerge(
        'ui-styled-text',
        className,
        whiteLabel,
        size === 'sm' ? 'text-sm' : size,
        colorMode,
        isDarkenedOnHover && 'is-darkened-on-hover',
        isActive && 'active',
        fontWeights[fontWeight],
        capitalize && 'capitalize',
        block && 'block'
      )}
    >
      {children}
    </span>
  )
}

const fontWeights: Record<FontWeight, string> = {
  standard: 'font-medium',
  thin: 'font-normal',
  semibold: 'font-semibold',
  bold: 'font-bold',
}
